import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { ArrowDown, GridViewIcon, ListViewIcon } from '../../constants/svg';
import { Form, Select, Input, Slider, Tooltip } from 'antd'
import FinancingCard from '../FinancingCard';

const { Option } = Select;

const locationOptions = ['New York', 'Los Angeles', 'Chicago', 'Houston'];
const providerOptions = ['Pharmacy A', 'Pharmacy B', 'Pharmacy C', 'Pharmacy D'];
const onFinish = (values) => {
    console.log('Success:', values);
};

const FinancingPlanContent = () => {
    const [location, setLocation] = useState(null);
    const [provider, setProvider] = useState(null);
    const [active, setActive] = useState(false);
    const [listView, setListView] = useState(false);

    const handleClick = () => {
        setActive(!active);
        setListView(!listView);
    };

    const handleLocationChange = (value) => {
        setLocation(value);
        console.log(`Selected location: ${value}`);
    };

    const handleProviderChange = (value) => {
        setProvider(value);
        console.log(`Selected care provider: ${value}`);
    };
    const FinancingCardData = [
        {
            id: 1,
            planName: "Finance Plan 1",
            discription: "lorem ipsum dolor sit amet, lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore ",
            planDetail: [
                {
                    id: 1,
                    planField: "Minimum Down Payment:",
                    planFieldValue: "75%",
                },
                {
                    id: 2,
                    planField: "Inerest Rate:",
                    planFieldValue: "25%",
                },
                {
                    id: 3,
                    planField: "Interest Rate Adjustment:",
                    planFieldValue: "Required",
                },
                {
                    id: 4,
                    planField: "Discount Eligibility:",
                    planFieldValue: "10%",
                },
                {
                    id: 5,
                    planField: "Calculation of Payment Schedule:",
                    planFieldValue: "Adhoc",
                },
                {
                    id: 6,
                    planField: "Late Payment Fees:",
                    planFieldValue: "$3000",
                },
                {
                    id: 7,
                    planField: "Insurance Claim Processing Fees:",
                    planFieldValue: "65%",
                },
                {
                    id: 8,
                    planField: "Extended Financing:",
                    planFieldValue: "10 Months",
                }
            ]
        },
        {
            id: 2,
            planName: "Finance Plan 2",
            discription: "lorem ipsum dolor sit amet, lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore ",
            planDetail: [
                {
                    id: 1,
                    planField: "Minimum Down Payment:",
                    planFieldValue: "75%",
                },
                {
                    id: 2,
                    planField: "Inerest Rate:",
                    planFieldValue: "25%",
                },
                {
                    id: 3,
                    planField: "Interest Rate Adjustment:",
                    planFieldValue: "Required",
                },
                {
                    id: 4,
                    planField: "Discount Eligibility:",
                    planFieldValue: "10%",
                },
                {
                    id: 5,
                    planField: "Calculation of Payment Schedule:",
                    planFieldValue: "Adhoc",
                },
                {
                    id: 6,
                    planField: "Late Payment Fees:",
                    planFieldValue: "$3000",
                },
                {
                    id: 7,
                    planField: "Insurance Claim Processing Fees:",
                    planFieldValue: "65%",
                },
                {
                    id: 8,
                    planField: "Extended Financing:",
                    planFieldValue: "10 Months",
                }
            ]
        }
        ,
        {
            id: 3,
            planName: "Finance Plan 3",
            discription: "lorem ipsum dolor sit amet, lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore ",
            planDetail: [
                {
                    id: 1,
                    planField: "Minimum Down Payment:",
                    planFieldValue: "75%",
                },
                {
                    id: 2,
                    planField: "Inerest Rate:",
                    planFieldValue: "25%",
                },
                {
                    id: 3,
                    planField: "Interest Rate Adjustment:",
                    planFieldValue: "Required",
                },
                {
                    id: 4,
                    planField: "Discount Eligibility:",
                    planFieldValue: "10%",
                },
                {
                    id: 5,
                    planField: "Calculation of Payment Schedule:",
                    planFieldValue: "Adhoc",
                },
                {
                    id: 6,
                    planField: "Late Payment Fees:",
                    planFieldValue: "$3000",
                },
                {
                    id: 7,
                    planField: "Insurance Claim Processing Fees:",
                    planFieldValue: "65%",
                },
                {
                    id: 8,
                    planField: "Extended Financing:",
                    planFieldValue: "10 Months",
                }
            ]
        }
    ]
    return (
        <>
            <div className="stats-box">
                <Row>
                    <Col lg={4}>
                        <Form.Item
                            label="Location"
                            name="location"
                            rules={[
                                {
                                    required: false,
                                    message: "Please select location",
                                },
                            ]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            className="m-0"
                        >
                            <Select
                                placeholder="Select Location"
                                onChange={handleLocationChange}
                                value={location}
                                suffixIcon={<ArrowDown />}
                            >
                                {locationOptions.map((location) => (
                                    <Option key={location} value={location}>
                                        {location}
                                    </Option>
                                ))}
                            </Select>

                        </Form.Item>
                    </Col>
                    <Col lg={4}>
                        <Form.Item
                            label="Select Care Provider"
                            name="careProvider"
                            rules={[
                                {
                                    required: false,
                                    message: "Please select location",
                                },
                            ]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            className="m-0"
                        >
                            <Select
                                placeholder="Select Care Provider"
                                onChange={handleProviderChange}
                                value={provider}
                                suffixIcon={<ArrowDown />}
                            >
                                {providerOptions.map((provider) => (
                                    <Option key={provider} value={provider}>
                                        {provider}
                                    </Option>
                                ))}
                            </Select>

                        </Form.Item>
                    </Col>
                    <Col lg={4}>
                        <div className="view-iconlist">
                            <div className={`view-iconItem ${active ? '' : 'active'}`} onClick={handleClick}>
                                <GridViewIcon />
                            </div>

                            <div className={`view-iconItem ${active ? 'active' : ''}`} onClick={handleClick}>
                                <ListViewIcon />
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <Row gutter={[16, 16]}>
                {FinancingCardData.map((data, index) => {
                    return (
                        <Col xs={12} md={6} lg={4} xl={4} className={`mb-4 pe-2 ps-2 ${listView ? 'w-100 listView' : ''}`} key={index}>
                            <FinancingCard financingdata={data} />
                        </Col>
                    )
                })}
            </Row>
        </>
    )
}

export default FinancingPlanContent